module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    style: ('border-radius: 8px; padding: 0.5em; background: ' + _vm.color)
  }, [(_vm.qrCode) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.qrCode.src
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [(_vm.txt) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.txt,
      "placement": "top"
    }
  }, [_c('el-button', {
    staticClass: "pull-left",
    attrs: {
      "type": "text",
      "icon": "fa fa-eye"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "pull-left",
    attrs: {
      "type": "text",
      "icon": "fa fa-sync"
    },
    on: {
      "click": _vm.generate
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "fa fa-download",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.downloadFile(_vm.qrCode.src)
      }
    }
  }), _vm._v(" "), (_vm.color) ? _c('switch-input', {
    attrs: {
      "size": "mini",
      "on-text": "Color",
      "off-text": "B&W",
      "no-form": ""
    },
    on: {
      "change": _vm.bgChanged
    },
    model: {
      value: (_vm.bw),
      callback: function($$v) {
        _vm.bw = $$v
      },
      expression: "bw"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-545d30e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/QrCode.vue
// module id = 1569
// module chunks = 0